"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettState = void 0;
var SettState;
(function (SettState) {
    SettState["Open"] = "open";
    SettState["Guarded"] = "guarded";
    SettState["Experimental"] = "experimental";
    SettState["Deprecated"] = "deprecated";
})(SettState = exports.SettState || (exports.SettState = {}));
//# sourceMappingURL=sett-state.enum.js.map